import axios from 'axios';
import get from 'lodash.get';
import { LogService } from '../../services/log-service';
import { PAGE_SIZE_250, PAGE_SIZE_5 } from '../../services/pagination-service';

const activityData = (apiUrl) =>
  axios
    .get(apiUrl)
    .then((response) => {
      return get(response, 'data', undefined);
    })
    .catch((err) => LogService.logError(new Error('Error fetching fulfillment plan activity', { cause: err })));

export const getFulfillmentPlanActivity = (fulfillmentPlanId, page = 0, pageSize = PAGE_SIZE_250) => {
  return activityData(`/fulfillmentPlanActivity/${fulfillmentPlanId}?page=${page}&pageSize=${pageSize}`);
};

export const getNewFulfillmentPlanActivity = (fulfillmentPlanId, pageSize = PAGE_SIZE_5, pageToken = '') => {
  return activityData(`/fulfillmentPlanActivity/v2/${fulfillmentPlanId}?pageSize=${pageSize}&pageToken=${pageToken}`);
};
